module.exports = __webpack_public_path__ + "media/images/lp/lp_ogp_banner-1b9f32d94d00c8e3acb38b78d554799d.png";